import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function ForgotPassword() {
    const [isVisible, setIsVisible] = useState(false);
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [emailError, setEmailError] = useState("");

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setError("");

        if (value && !validateEmail(value)) {
            setEmailError("Geçerli bir email adresi giriniz");
        } else {
            setEmailError("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!email.trim()) {
            setEmailError("Email adresi gerekli");
            return;
        }

        if (!validateEmail(email)) {
            setEmailError("Geçerli bir email adresi giriniz");
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch("/rest/User/forgotPassword", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email.trim(),
                }),
            });

            const responseData = await response.json();
            console.log("Response status:", response.status);
            console.log("Response data:", responseData);

            if (responseData.statusCode && responseData.statusCode >= 400) {
                if (responseData.statusCode === 404) {
                    throw new Error("Bu email adresine kayıtlı bir hesap bulunamadı.");
                } else if (responseData.statusCode >= 500) {
                    throw new Error("Sunucu hatası. Lütfen daha sonra tekrar deneyin.");
                } else {
                    throw new Error(responseData.message || "Bir hata oluştu. Lütfen tekrar deneyin.");
                }
            }

            setSuccess(true);
        } catch (error) {
            console.error("Forgot password error:", error);
            setError(error.message || "Şifre sıfırlama isteği gönderilirken bir hata oluştu");
        } finally {
            setIsLoading(false);
        }
    };

    if (success) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
                <div
                    className="absolute inset-0 opacity-20 bg-cover bg-center"
                    style={{ backgroundImage: `url(/images/sea-bg-2.jpg)` }}
                ></div>
                <div className="relative w-full max-w-md p-8 bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10">
                    <div className="text-center">
                        <div className="w-16 h-16 bg-green-500/20 border border-green-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg
                                className="w-8 h-8 text-green-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-white mb-4">Email Gönderildi!</h2>
                        <p className="text-white/70 mb-8 leading-relaxed">
                            Şifre sıfırlama bağlantısı <strong className="text-blue-400">{email}</strong> adresine gönderildi.
                            Lütfen email kutunuzu kontrol edin.
                        </p>
                        <div className="space-y-4">
                            <Link
                                to="/login"
                                className="block w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5 text-center font-medium"
                            >
                                Giriş Sayfasına Dön
                            </Link>
                            <p className="text-white/50 text-sm">
                                Email gelmedi mi?{" "}
                                <button
                                    onClick={() => {
                                        setSuccess(false);
                                        setEmail("");
                                    }}
                                    className="text-blue-400 hover:text-blue-300 transition-colors underline"
                                >
                                    Tekrar dene
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
            <div
                className="absolute inset-0 opacity-20 bg-cover bg-center"
                style={{ backgroundImage: `url(/images/hero-2.jpg)` }}
            ></div>
            <div
                className={`relative w-full max-w-md p-8 bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10 transition-all duration-700 transform ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-12"
                }`}
            >
                {/* Üst Navigasyon */}
                <div className="absolute -top-12 left-0">
                    <Link
                        to="/login"
                        className="text-white/60 hover:text-white flex items-center gap-2 transition-colors duration-300"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        <span>Giriş Yap</span>
                    </Link>
                </div>

                {/* Header */}
                <div
                    className={`mb-8 text-center transition-all delay-300 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <Link
                        to="/"
                        className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent inline-flex items-center gap-2"
                    >
                        Cyprus Yacht Club
                        <span className="text-2xl">⛵</span>
                    </Link>
                    <p className="mt-2 text-white/60">
                        Şifrenizi mi unuttunuz?
                    </p>
                    <p className="mt-1 text-white/40 text-sm">
                        Email adresinizi girin, size sıfırlama bağlantısı gönderelim
                    </p>
                </div>

                {/* Hata Mesajı */}
                {error && (
                    <div className="mb-4 p-3 bg-red-500/20 border border-red-500/30 rounded-xl text-red-400 text-sm">
                        {error}
                    </div>
                )}

                <form
                    onSubmit={handleSubmit}
                    className={`space-y-6 transition-all delay-500 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Email Adresi
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                emailError
                                    ? "border-red-500/50 focus:border-red-500"
                                    : "border-white/10 focus:border-blue-500"
                            }`}
                            placeholder="mail@example.com"
                            required
                        />
                        {emailError && (
                            <p className="mt-2 text-red-400 text-sm">{emailError}</p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading || emailError || !email.trim()}
                        className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center gap-2">
                                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                Gönderiliyor...
                            </div>
                        ) : (
                            "Devam"
                        )}
                    </button>

                    <div className="text-center text-white/60 text-sm">
                        Şifrenizi hatırladınız mı?{" "}
                        <Link
                            to="/login"
                            className="text-blue-400 hover:text-blue-300 transition-colors"
                        >
                            Giriş Yap
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ForgotPassword;